import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../../../../stores/hooks";
import type { ActionGroupProps } from "../../types";
import { useActionDetails } from "../../hooks/useActionDetails";
import { ActionDetailsContainer } from "../common/ActionDetailsContainer";
import { InputList } from "../common/InputList/InputList";
import { getInputValue as defaultGetInputValue } from "../../../GeneralActionResultGroup/utils";
import { WithFindWrapper } from "../common/WithFindWrapper/WithFindWrapper";
import { RECORD_ID } from "../../../../../../../utils/constants";
import {
  addEmptyValueIfNeeded,
  findRecordIdValue,
} from "../../../../../ActivityGrid/ActivityGrid.helpers";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";

export const GeneralLoopingActionResultGroup = observer<ActionGroupProps>(
  ({
    action,
    recordJobData,
    recordJobDataByDetailsId,
    recordJobIds,
    onDetailsClick,
    onRecordClick,
    getInputValue: customGetInputValue,
  }) => {
    const { jobDetails } = useRootStore();
    const { status, errorMessage, actionLabel, selectedActionFallback } =
      useActionDetails(action);

    return (
      <ActionDetailsContainer
        label={actionLabel}
        status={status}
        errorMessage={errorMessage}
        onDetailsClick={onDetailsClick}
      >
        <WithFindWrapper
          recordJobData={recordJobData}
          recordJobDataByDetailsId={recordJobDataByDetailsId}
          recordJobIds={recordJobIds}
          onRecordClick={onRecordClick}
        >
          {({ recordJobData }) => {
            const outputs =
              recordJobData?.outputData?.recordList?.recordList !== undefined
                ? recordJobData.outputData.recordList.recordList.records[0]
                    ?.outputs
                : undefined;
            const recordId = outputs?.find(
              (output) => output.outputId === RECORD_ID,
            );

            return (
              <>
                <InputList
                  recordJobData={recordJobData}
                  jobDetails={jobDetails}
                  action={action}
                  inputs={recordJobData?.inputs}
                  getInputValue={customGetInputValue ?? defaultGetInputValue}
                  selectedActionFallback={selectedActionFallback}
                />
                {recordId !== undefined && (
                  <ActivityDetailsItem label={recordId.outputLabel}>
                    {addEmptyValueIfNeeded(findRecordIdValue(recordJobData))}
                  </ActivityDetailsItem>
                )}
              </>
            );
          }}
        </WithFindWrapper>
      </ActionDetailsContainer>
    );
  },
);
